import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AppConfig } from 'client/app/app.config';

@Component({
  selector: 'missed-doctor-call',
  templateUrl: './missed-doctor-call.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class MissedDoctorCallComponent {
  @Output('openReAcquisitionPage') openReAcquisitionPage: EventEmitter<any> = new EventEmitter();
  @Input() isReAcquistionRebrandingExpEnabled: boolean = false;
  @Input() userFirstName: string = '';
  constructor(
    public appConfig: AppConfig,
  ) { }

  handleClick(): void {
    this.openReAcquisitionPage.emit();
  }
}
